module.exports = __webpack_public_path__ + "static/img/200227.53533721.png";